import { VIEWS } from '../../constants';

// Recharge les absences, les soldes CP qu'elles ont pu modifier en base, et les vues ouvertes qui
// les affichent.
export async function refreshAbsences({ appState, timesheetUserId, timesheetMonth }, api) {
  await Promise.all([api.loadAbsences(), api.refreshLeaveBalances()]);
  if (appState.view === VIEWS.PROFILE || appState.view === VIEWS.LEAVE) api.loadUserAbsences();
  if (appState.view === VIEWS.TIMESHEETS) api.loadTimesheetMonth(timesheetMonth, timesheetUserId);
}
